<template>
  <div class="custom-key-page">
    <el-dialog title="字段管理" :visible.sync="currentValue" width="1200px" :wrapperClosable="false" :close-on-click-modal="false" :append-to-body="false" custom-class="custom-key-page-template">
      <div class="search-table">
        <div class="search-table-tool">
          <el-input prefix-icon="iconfont iconicon_search1" @input="searchChange" class="fliter-input" v-model="ruleForm.keyword" size="mini" placeholder="搜索字段名称" clearable @keyup.enter.native="searchChange"></el-input>
        </div>
        <div>
          <el-button size="mini" type="primary" @click="addNewKey">新增字段</el-button>
          <!-- <el-button size="mini" type="primary" @click="showPreView">预览</el-button> -->
        </div>
      </div>
      <commonTable @button-click="addNewKey" tableHead="customKey" ref="commonTable" :config="{nothing}" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="true" :isSelfMak="true" >
        <template slot="component_code" slot-scope="scope">
          <span>{{templateConfig[scope.data.component_code].standard_component_name}}</span>
        </template>
        <template slot="is_show" slot-scope="scope">
          <span>{{scope.data.is_show ? '使用中' :'未使用'}}</span>
        </template>
        <template slot="verifyRemark" slot-scope="scope">
          <span @click="editCustom(scope)">编辑</span>
          <span @click="delCustom(scope)">{{scope.data.is_show ? '禁用' :'启用'}}</span>
        </template>
      </commonTable>
    </el-dialog>
    <el-dialog :title="isEdit ? '编辑字段' : '新建字段'" :visible.sync="dialogVisible" width="30%" :wrapperClosable="false" :close-on-click-modal="false" :append-to-body="false">
      <dialogEle  v-if="dialogVisible" @success="success" :editData="editData" :dialogVisible="dialogVisible" @cancel="dialogVisible = false" :isEdit="isEdit" :projectId="project_id" @change="editDialogChange"></dialogEle>
    </el-dialog>
  </div>
</template>
<script>
import dialogEle from './dialog'
import { mapState } from 'vuex'
export default {
  props: ['value'],
  components: {
    dialogEle,
  },
  data() {
    return {
      timer: '',
      dialogVisible: false,
      ruleForm: {
        keyword: ''
      },
      project_id: '',
      editData: {},
      isEdit: false,
      previewDialog: false,
      taskInfo: {},
      openIndex: 0,
    }
  },
  computed: {
    ...mapState('template/template', {
      tableData: state => state.dataset
    }),
    ...mapState('customKey/customKey', {
      templateConfig: state => state.templateConfig
    }),
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    nothing() {
      return {
        tip: this.ruleForm.keyword ? '暂无搜索内容' : '暂无字段信息，快去添加自定义字段吧',
        type: this.ruleForm.keyword ? 'img_search' : 'img_add_task',
        btnText: this.ruleForm.keyword ? '' : '新增字段',
        permission: ''
      }
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    success() {
      this.init()
      this.dialogVisible = false
    },
    getTableList() {
      this.$nextTick(() => {
        this.$refs?.commonTable?.selfPageSplit(this.tableData?.task_template_content?.template_standard_components || [])
      })
    },
    editDialogChange(val, flg) {
      if(!this.tableData.task_template_content) {
        this.tableData.task_template_content = {
          project_id: 0,
          sort_rule_type_id: 1,
          template_desc: '任务通用模板',
          template_name: '任务通用模板'
        }
        this.tableData.task_template_content.template_standard_components = []
      }
      if(flg) {
        let index = this.tableData?.task_template_content?.template_standard_components.findIndex(res => res.sort === this.openIndex)
        let value = {...this.tableData.task_template_content.template_standard_components[index], ...val}
        console.log('----------fff---------', index, this.openIndex)
        this.tableData.task_template_content.template_standard_components.splice(index, 1, JSON.parse(JSON.stringify(value)))
      } else {
        let value = {
          ...val,
          is_show: 1,
          sort: this.tableData?.task_template_content?.template_standard_components.length + 1
        }
        this.tableData.task_template_content.template_standard_components.push(value)
      }
      this.dialogVisible = false
      this.$refs?.commonTable?.selfPageSplit([])
      this.getTableList()
    },
    editCustom(result) {
      this.editData = JSON.parse(JSON.stringify(result.data))
      this.openIndex = result.data.sort
      this.dialogVisible = true
      this.isEdit = true
    },
    delCustom(data) {
      this.tableData.task_template_content.template_standard_components[data.index].is_show = 0
      this.getTableList()
    },
    searchChange() {
      clearInterval(this.timer)
      this.timer = ''
      this.timer = setInterval(() => {
        let arr = this.tableData.task_template_content.template_standard_components.filter(res => res.component_name_in_template.indexOf(this.ruleForm.keyword) > -1)
        this.$refs?.commonTable?.selfPageSplit(arr)
        clearInterval(this.timer)
        this.timer = ''
      }, 300)
    },
    addNewKey() {
      this.isEdit = false
      this.dialogVisible = true
    },
    showPreView() {
      this.previewDialog = true
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
